mutation CancelCharityContactInvite($input: CancelCharityContactInviteInput!) {
  cancelCharityContactInvite(input: $input) {
    success
  }
}
